
define('text!TescoMobile_Sso/template/form/links/forgotten-username.html',[],function () { return '<div class="field"><strong data-bind="i18n: \'Forgotten\'"></strong> <a class="action remind" data-bind="attr: {href: getUrl()}" target="_blank"><span data-bind="i18n: \'username\'"></span> </a><strong>?</strong></div>';});

